export enum AanbiedingSoort {
    Normaal = 0,
    Mijngrossier = 1
}
